import { PharmacInput, PharmacInputError, PharmacLabel } from '@pharmac/ui'
import { Controller } from 'react-hook-form'
import { ControlledInputProps } from './dto'
import {
  isMaxLengthError,
  isMinLengthError,
  isPatternError,
  isRequiredError,
  isValidateError,
} from './form.util'

type ControlledTextEditorErrorProps = {
  maxLengthError?: string
  requiredError?: string
  patternError?: string
  minLengthError?: string
  validateError?: string
}

export const ControlledInput = (props: ControlledInputProps & ControlledTextEditorErrorProps) => {
  const isRequired = !!props.rules && !!props.rules.required

  return (
    <>
      {!!props.label && (
        <PharmacLabel marginSmallBottom>
          {props.label} {isRequired && '*'}
        </PharmacLabel>
      )}
      <Controller
        name={props.name}
        control={props.control}
        rules={props.rules}
        render={({ field, formState }) => {
          // eslint-disable-next-line
          const { ref, ...f } = field

          const errorOrUndefined = formState.errors[props.name]

          return (
            <>
              <PharmacInput
                {...f}
                autoComplete={props.autoComplete}
                value={f.value ?? ''}
                hasError={!!errorOrUndefined}
                placeholder={props.placeholder}
                disabled={props.disabled}
                type={props.type}
                posticon={props.posticon}
                readOnly={props.readOnly}
              />
              {isRequiredError(errorOrUndefined) && props.requiredError && (
                <PharmacInputError>{props.requiredError}</PharmacInputError>
              )}
              {isMaxLengthError(errorOrUndefined) && props.maxLengthError && (
                <PharmacInputError>{props.maxLengthError}</PharmacInputError>
              )}
              {isMinLengthError(errorOrUndefined) && props.minLengthError && (
                <PharmacInputError>{props.minLengthError}</PharmacInputError>
              )}
              {isPatternError(errorOrUndefined) && props.patternError && (
                <PharmacInputError>{props.patternError}</PharmacInputError>
              )}
              {isValidateError(errorOrUndefined) && props.validateError && (
                <PharmacInputError>{props.validateError}</PharmacInputError>
              )}
            </>
          )
        }}
      />
    </>
  )
}
